import { pgTable, text, boolean, timestamp, integer, index, uniqueIndex } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

/**
 * Language — available languages for UI translations
 */
export const language = pgTable('Language', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  code: text().notNull(),
  name: text().notNull(),
  originalName: text().notNull(),
  flagEmoji: text(),
  isDefault: boolean().default(false).notNull(),
  isActive: boolean().default(true).notNull(),
  sortOrder: integer().default(0).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  uniqueIndex('Language_code_key').using('btree', table.code.asc().nullsLast()),
  index('Language_isActive_idx').using('btree', table.isActive.asc().nullsLast()),
]);

/**
 * UiTranslation — UI translation key-value pairs per language
 */
export const uiTranslation = pgTable('UiTranslation', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  languageCode: text().notNull(),
  key: text().notNull(),
  value: text().notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
  updatedAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  uniqueIndex('UiTranslation_languageCode_key_key').using('btree', table.languageCode.asc().nullsLast(), table.key.asc().nullsLast()),
  index('UiTranslation_languageCode_idx').using('btree', table.languageCode.asc().nullsLast()),
]);
